import { render } from "./AppBar.vue?vue&type=template&id=b15a5142"
import script from "./AppBar.vue?vue&type=script&lang=js"
export * from "./AppBar.vue?vue&type=script&lang=js"

import "./AppBar.vue?vue&type=style&index=0&id=b15a5142&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__